import { render, staticRenderFns } from "./LocationsDrawer.vue?vue&type=template&id=58c58b63&scoped=true"
import script from "./LocationsDrawer.vue?vue&type=script&lang=ts"
export * from "./LocationsDrawer.vue?vue&type=script&lang=ts"
import style0 from "./LocationsDrawer.vue?vue&type=style&index=0&id=58c58b63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c58b63",
  null
  
)

export default component.exports